import React from 'react';
import { UniversalLink } from '@plone/volto/components';

type ContentTagsProps = {
  tags: string[];
};

function buildTagUrl(tag: string) {
  return `/search?Subject=${encodeURIComponent(tag)}`;
}

export default function ContentTags({ tags }: ContentTagsProps) {
  if (!tags.length) return null;

  return (
    <section
      className="content-view__tags"
      aria-labelledby="content-tags-title"
    >
      <h2 id="content-tags-title" className="content-view__section-title">
        Tags:
      </h2>

      <ul className="content-view__tags-list">
        {tags.map((tag) => (
          <li key={tag} className="content-view__tag-item">
            <UniversalLink
              href={buildTagUrl(tag)}
              className="content-view__tag"
              title={`Ver conteúdos da tag ${tag}`}
              aria-label={`Ver conteúdos da tag ${tag}`}
            >
              {tag}
            </UniversalLink>
          </li>
        ))}
      </ul>
    </section>
  );
}
